import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the IntrestRateMovementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intrest-rate-movement',
  templateUrl: 'intrest-rate-movement.html',
})
export class IntrestRateMovementPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad IntrestRateMovementPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/intrest-rate-movement/intrest-rate-movement.ts